import { useLocation, useSearchParams } from "react-router";
import { useTimezone } from "src/business-components/input/TimeZoneSelector/TimeZoneSelector.hooks";
import { useShowFilters } from "src/components/features/medium/AssetsFilter/AssetsFilters.hooks";
import { useCommonQueryParams } from "src/queries/useCommonQueryParams";
import {
  useAiContextItems,
  useRemoveAiContext,
} from "../../AiToolboxSection.context";
import { useFilterDisplayNames } from "../../AiToolboxSection.hooks";
import { AI_CONTEXT_QUERY_PARAMS } from "./AiAssistantChatContext.constants";
import { parseUrlAsChatContext } from "./AiAssistantChatContext.utils";

/**
 * Hook to get the current chat context from the current URL
 */
export const useAiAssistantChatCurrentContext = () => {
  const { tzStr } = useTimezone();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const commonParams = useCommonQueryParams(AI_CONTEXT_QUERY_PARAMS);
  const { showTimeFilter } = useShowFilters();
  const { tagNamesById, userNamesById } = useFilterDisplayNames();

  const extraContextItems = useAiContextItems();
  const removeContextItem = useRemoveAiContext();

  const filteredCommonParams = showTimeFilter
    ? commonParams
    : { ...commonParams, timeWindow: undefined };

  const entries = parseUrlAsChatContext({
    pathname,
    searchParams,
    commonParams: filteredCommonParams,
    tagNamesById,
    userNamesById,
    tzStr,
  });

  return {
    entries,
    extraContextItems,
    removeContextItem,
  };
};
